import { render, staticRenderFns } from "./CourseCardSelected.vue?vue&type=template&id=305b8c86&scoped=true&"
import script from "./CourseCardSelected.vue?vue&type=script&lang=js&"
export * from "./CourseCardSelected.vue?vue&type=script&lang=js&"
import style0 from "./CourseCardSelected.vue?vue&type=style&index=0&id=305b8c86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305b8c86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardText,VContainer,VHover,VImg,VToolbarTitle})
